// src/pages/AboutPage.js

import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <PublicNavbar />
      
      {/* New Hero Section */}
      <header className="about-hero">
        <div className="about-hero-content">
          <h1>About Us</h1>
          <p>Feeling that the community really cares</p> 
          <p>can start their path to recovery.</p>
        </div>
      </header>

      {/* Main page content */}
      <div className="about-main-content">
        <main>
          <section className="about-section">
            <h2>From a Simple Idea to a Lifeline</h2>
            <p>
              Inclusive AI was founded on a simple, powerful belief: everyone deserves a fair chance to build a new life, regardless of their starting point. We see countless individuals, facing immense challenges and they are often doing it all on their own. After a major setback, they are looking for a job, trying to find a place to live, or simply looking for their next meal. Particularly the people who have just become homeless often find it difficult to identify what resources are available to them.
            </p>
            <p>
              That's where Inclusive Ai can help. We envisioned a single, intuitive app that could act as a trusted friend and guide, putting essential resources directly into the hands of those who need them most. We wanted to do more than just provide a list of addresses; we are building a hub that empowers, encourages, and facilitates those crucial first steps toward stability and success.  
            </p>
          </section>
          <section className="about-section">
            <h2>Connecting People to Resources</h2>
            <p> 
              Our resource finder is more than maps software, it is a curated list of caring support from your community. By partnering with local nonprofits, community organizations, and dedicated contributors, we provide a network of verified, high-quality free resources that are available right now. Our resource finder is designed with one goal in mind: to remove barriers and allow people to meet their needs.            
            </p>
          </section>
          {/* MODIFIED: Added 'about-section' and 'about-image-container' classes for consistent layout */}
          <section className="about-section about-image-container">
            <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fabout_services.jpg?alt=media&token=3db55523-19f2-45ec-ae26-763d5490994a" alt="Community services and support network" />
          </section>
          <section className="about-section">
            <h2>Virtual Employment Coaching</h2>
            <p> 
              After they have met their immediate needs, finding a new job is the most important next step. Our app includes valuable tools that will ensure success finding and securing good employment. Many people who have not experienced down-sizing are inexperienced in knowing where to find employment opportunities. Professional tips and guidelines on how to write a resume, what to say in an interview and more are included so that they can get back on their feet.            
            </p>
          </section>
        </main>
      </div>

      <footer className="about-footer">
        <p>&copy; 2025 Inclusive AI. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default AboutPage;